export function roleValidate(role){
    var result = true;

    result = validateId(role.id);
    result = validateName(role.name);
    result = validatePermissions(role.permissions);

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name)  {
    if(typeof name == "string" && name !== "") return true;
    else return false;
}

function validatePermissions(permissions) {
    if(Array.isArray(permissions) && permissions.length !== 0) return true;
    else return false;
}